import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock, Instagram, Facebook } from 'lucide-react';
import { CONTACT } from '../mock/data';

export default function Footer() {
  return (
    <footer className="bg-ink text-cream/80">
      <div className="max-w-7xl mx-auto px-6 py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-1">
          <div className="flex flex-col w-52 leading-none">
            <img src="/vivamore-mark.webp" alt="Vivamore Dining" className="w-full h-auto block" />
            <div className="flex justify-between w-full mt-1.5 text-[9px] uppercase text-cream font-medium">
              <span>Convenient</span>
              <span>&middot;</span>
              <span>Connect</span>
              <span>&middot;</span>
              <span>Celebrate</span>
            </div>
          </div>
          <div className="gold-line my-6" />
          <p className="text-sm leading-relaxed font-light">
            Elegant dining & thoughtful celebrations. A premium contemporary destination in the heart of Kuala Lumpur.
          </p>
          <div className="flex gap-4 mt-6">
            <a href={CONTACT.instagram} target="_blank" rel="noopener noreferrer" className="w-10 h-10 border border-cream/25 flex items-center justify-center hover:bg-gold hover:border-gold transition-colors" aria-label="Instagram">
              <Instagram size={17} />
            </a>
            <a href={CONTACT.facebook} target="_blank" rel="noopener noreferrer" className="w-10 h-10 border border-cream/25 flex items-center justify-center hover:bg-gold hover:border-gold transition-colors" aria-label="Facebook">
              <Facebook size={17} />
            </a>
            <a href={CONTACT.tiktok} target="_blank" rel="noopener noreferrer" className="w-10 h-10 border border-cream/25 flex items-center justify-center hover:bg-gold hover:border-gold transition-colors" aria-label="TikTok">
              <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
                <path d="M16.5 3c.3 2.1 1.6 3.7 3.7 4v2.4c-1.4 0-2.7-.4-3.8-1.1v6.9c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6c.3 0 .6 0 .9.1v2.6c-.3-.1-.6-.2-.9-.2-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5 3.5-1.6 3.5-3.5V3h2.6z" />
              </svg>
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-xs tracking-luxe uppercase text-gold mb-6">Explore</h4>
          <ul className="space-y-3 text-sm font-light">
            {[['About', '/about'], ['Dining', '/dining'], ['Events', '/events'], ['Gallery', '/gallery'], ['Plan an Event', '/plan-event']].map(([t, u]) => (
              <li key={u}>
                <Link to={u} className="hover:text-gold transition-colors">{t}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs tracking-luxe uppercase text-gold mb-6">Visit Us</h4>
          <ul className="space-y-4 text-sm font-light">
            <li className="flex gap-3"><MapPin size={17} className="text-gold shrink-0 mt-0.5" /> {CONTACT.address}</li>
            <li className="flex gap-3"><Clock size={17} className="text-gold shrink-0 mt-0.5" /> {CONTACT.hours}</li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs tracking-luxe uppercase text-gold mb-6">Get in Touch</h4>
          <ul className="space-y-4 text-sm font-light">
            <li className="flex gap-3"><Phone size={17} className="text-gold shrink-0 mt-0.5" /> <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors">{CONTACT.phone}</a></li>
            <li className="flex gap-3"><Mail size={17} className="text-gold shrink-0 mt-0.5" /> <a href={`mailto:${CONTACT.email}`} className="hover:text-gold transition-colors">{CONTACT.email}</a></li>
          </ul>
          <a href={CONTACT.whatsappReserve} target="_blank" rel="noopener noreferrer" className="btn-gold inline-block mt-6 text-xs tracking-widest uppercase px-6 py-3 border border-gold text-gold hover:bg-gold hover:text-ink">
            Reserve A Table
          </a>
        </div>
      </div>
      <div className="border-t border-cream/10">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-cream/50">
          <p>© {new Date().getFullYear()} Vivamore. All rights reserved.</p>
          <p className="tracking-wider">Convenient · Connect · Celebrate</p>
        </div>
      </div>
    </footer>
  );
}
